import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {ValueDisplayable} from "../modules/ui/interface/value.displayable";

@JacksonType("AtividadeNacional")
@JsonIdentityInfo()
export class AtividadeNacional extends SonnerBaseEntity implements ValueDisplayable{

  id: number;

  ativa: boolean;

  nivel: number;

  codigo: string;

  codigoCompleto: string;

  nome: string;

  getDisplayValue(): string {
    return this.codigoCompleto + " - " + this.nome;
  }

}
